import React, { Component } from 'react'
import _Input from './Input/Input'

class Secret extends Component {
  state = {
    hidden: true
  }

  onChange = (e) => {
    const { onValueChange } = this.props
    const { value } = e && e.target
    onValueChange && onValueChange(value)
  }

  toggleHidden = () => {
    this.setState({
      hidden: !this.state.hidden
    })
  }

  render () {
    const { revealValue, value, icon } = this.props
    const { hidden } = this.state
    return (
      <_Input
        {...this.props}
        value={value || ''}
        type={hidden ? 'password' : 'text'}
        maxLength='80'
        onChange={this.onChange}
        // icon={revealValue ? (hidden && `eye`) || `eye-off` : ''}
        icon={
          value
            ? revealValue ? (hidden && `eye`) || `eye-off` : icon
            : icon
        }
        onIconClick={this.toggleHidden}
      />
    )
  }
}

export const Input = ({ onValueChange, ...props }) => {
  return (
    <Secret onValueChange={onValueChange} {...props} />
  )
}

export const Output = (props) => {
  return (
    <>
      {
        props.value || props.data
          ? <span>&#8226; &#8226; &#8226; &#8226; &#8226; &#8226; &#8226; &#8226;</span>
          : <span />
      }
    </>
  )
}
